






























import {
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency";
import { AdvisoryFund } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import InstrumentName from "./InstrumentName.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    InstrumentName,
    GenericLoadingSpinner
  }
})
export default class AdvisoryFunds extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;
  funds: AdvisoryFund[] = [];

  drivewealthStore = useDrivewealthStore();

  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop({ required: false }) accountId: number;

  @Watch("$props", { deep: true })
  onPropertyChange () {
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId });
  }

  mounted (): void {
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId });
  }

  get isLoaded (): boolean {
    return this.drivewealthStore.advisoryFundsLoaded;
  }

  fundFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Instrument"
    },
    {
      key: "fund_type",
      label: "Fund Type",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "shares",
      label: "Shares",
      thClass: "text-right",
      tdClass: "text-right"
    },
    {
      key: "balance",
      label: "Balance",
      thClass: "text-right",
      tdClass: "text-right"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center"
    }
  ];

  get fundItems () {
    if (!this.drivewealthStore.advisoryFunds) {
      return [];
    }

    return this.drivewealthStore.advisoryFunds.map(f => ({
      instrument: { symbol: f.stockSymbol, companyName: f.company, website: f.website, imageUrl: f.imageUrl },
      status: f.status,
      fund_type: f.fundType,
      balance: f.balance === null ? "" : formatCurrency(f.balance),
      shares: f.sharesOwned === null ? "" : f.sharesOwned.toFixed(3),
      action: { symbol: f.stockSymbol }
    }));
  }

  routeParams (symbol: string): { symbol: string, accountId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId };
    }

    return { symbol };
  }

  get buyRoute (): string {
    if (this.accountId) {
      return RouteNames.DrivewealthBuyInstrumentV2;
    }

    return RouteNames.DrivewealthBuyInstrument;
  }


  get canBuy () {
    return !this.username;
  }
}
